import apiPasarela from "./apiPasarela";

// Capa de servicio del módulo de Soportes (Modo Integración).
//
// El frontend habla SIEMPRE con el backend de pasarela (apiPasarela → /soporte/*).
// Ese backend inyecta la X-Integration-Key (secreta, server-to-server) y fija el
// external_id (= id de la tabla clientes) hacia api_go_soporte. El navegador NUNCA
// ve la API key del proyecto de soporte.
//
// Cada request lleva:
//   - query `cliente_id`  → el external_id (id de la tabla clientes; se valida en el back).
//   - header `X-Actor-Email` → atribución del autor (email del usuario logueado).
// El Bearer del usuario lo agrega el interceptor de apiPasarela.

function buildConfig(clienteId, actorEmail, extra = {}) {
  const params = { ...(extra.params || {}) };
  const headers = { ...(extra.headers || {}) };
  if (clienteId !== null && clienteId !== undefined && clienteId !== "") {
    params.cliente_id = clienteId;
  }
  if (actorEmail) {
    headers["X-Actor-Email"] = actorEmail;
  }
  return { params, headers };
}

export const Soportes = {
  // Catálogo de categorías (global) para el selector de "Nuevo ticket".
  getCategorias(clienteId, actorEmail) {
    return apiPasarela
      .get("/soporte/categories", buildConfig(clienteId, actorEmail))
      .then((r) => r.data);
  },

  // Listar tickets del cliente (el alcance lo fuerza el back por el external_id).
  // params: { page, per_page, search, estado, prioridad, categoria, visto }
  getSoportes(clienteId, actorEmail, params) {
    return apiPasarela.get(
      "/soporte/tickets",
      buildConfig(clienteId, actorEmail, { params })
    );
  },

  // Detalle de un ticket (ticket + responses + attachments con URLs pre-firmadas).
  // opts: { include_thumbs: 1 } opcional.
  getSoporteDetail(clienteId, actorEmail, ticketId, opts) {
    return apiPasarela
      .get(`/soporte/tickets/${ticketId}`, buildConfig(clienteId, actorEmail, { params: opts }))
      .then((r) => r.data);
  },

  // Crear ticket (JSON, sin adjuntos).
  createSoporteJson(clienteId, actorEmail, payload) {
    return apiPasarela.post("/soporte/tickets", payload, buildConfig(clienteId, actorEmail));
  },

  // Crear ticket (multipart one-shot, con adjuntos).
  createSoporteMultipart(clienteId, actorEmail, formData) {
    return apiPasarela.post("/soporte/tickets", formData, buildConfig(clienteId, actorEmail));
  },

  // Crear respuesta (JSON, sin archivo).
  createRespuestaJson(clienteId, actorEmail, ticketId, payload) {
    return apiPasarela.post(
      `/soporte/tickets/${ticketId}/responses`,
      payload,
      buildConfig(clienteId, actorEmail)
    );
  },

  // Crear respuesta (multipart, con archivo adjunto).
  createRespuestaMultipart(clienteId, actorEmail, ticketId, formData) {
    return apiPasarela.post(
      `/soporte/tickets/${ticketId}/responses`,
      formData,
      buildConfig(clienteId, actorEmail)
    );
  },

  // Cambiar estado / prioridad / abierta del ticket.
  putSoporte(clienteId, actorEmail, ticketId, payload) {
    return apiPasarela.patch(
      `/soporte/tickets/${ticketId}`,
      payload,
      buildConfig(clienteId, actorEmail)
    );
  },

  // Marcar ticket como leído.
  markSoporteRead(clienteId, actorEmail, ticketId) {
    return apiPasarela.post(
      `/soporte/tickets/${ticketId}/mark-read`,
      null,
      buildConfig(clienteId, actorEmail)
    );
  },

  // Listar adjuntos del ticket.
  listAttachments(clienteId, actorEmail, ticketId) {
    return apiPasarela
      .get(`/soporte/tickets/${ticketId}/attachments`, buildConfig(clienteId, actorEmail))
      .then((r) => r.data);
  },

  // Subir un adjunto suelto a un ticket.
  uploadAttachment(clienteId, actorEmail, ticketId, formData) {
    return apiPasarela.post(
      `/soporte/tickets/${ticketId}/attachments`,
      formData,
      buildConfig(clienteId, actorEmail)
    );
  },

  // Pedir un token efímero de WebSocket (tiempo real). El back lo obtiene de
  // soporte (/realtime-token) sin exponer la X-Integration-Key.
  realtimeToken(clienteId, actorEmail) {
    return apiPasarela
      .post("/soporte/realtime-token", null, buildConfig(clienteId, actorEmail))
      .then((r) => r.data);
  },

  // Fallback legacy: descarga un archivo por el endpoint viejo de pasarela.
  // En el flujo de integración los adjuntos vienen con URL pre-firmada (att.url),
  // así que esto casi no se usa; se mantiene por compatibilidad.
  getSoporteFile(archivo) {
    return apiPasarela.get("/administracion/soportes-file", { params: { archivo } });
  },
};
